/** 拨号状态 **/
<template>
  <div class="home data-panel-home dial-status-home">
    <Layout type="HOME" pageTitle="软路由" titleSrc="/menu/dialStatus.png">
      <div style="width: 100%;text-align: right;">
        <div class="sure-unbind button" style="width: 140px;" type="primary" @click="exportInfo">导出异常拨号信息</div>
      </div>
      <!-- 设备总览 -->
      <BasiceLayout title="设备总览" class="bonus-code-layout revenue-all-layout ">
        <div class="BasicInput">
          <div class="revenueWrap top_total_revenue">
            <!-- 账号总数 -->
            <div class="one_day_revenue each_item_wrap ">
              <div class="revenue_item">
                <div class="revenue_title">节点总数</div>
              </div>
              <div class="revunue_value" v-if="total || total == 0">{{total}} 台</div>
              <div class="revunue_value" v-if="!total && total !== 0">-</div>
            </div>
            <!-- 拨号正常节点数量 -->
            <div class="one_day_invite_revenue each_item_wrap">
              <div class="revenue_item">
                <div class="revenue_title">拨号正常节点数量</div>
              </div>
              <div class="revunue_value" v-if="normal || normal == 0">{{ normal }} 台</div>
              <div class="revunue_value" v-if="!normal && normal !== 0">-</div>
            </div>
            <!-- 拨号异常节点数量 -->
            <div class="total_revenue each_item_wrap">
              <div class="revenue_item">
                <div class="revenue_title">拨号异常节点数量</div>
              </div>
              <div class="revunue_value" v-if="error || error == 0">{{ error }} 台
              </div>
              <div class="revunue_value" v-if="!error && error !== 0">- </div>
            </div>
          </div>
        </div>
      </BasiceLayout>
      <!-- 拨号状态 -->
      <BasiceLayout title="拨号状态" class="bonus-code-layout margin-top-20">
        <div v-if="serverList && serverList.length && serverList !== 'NODATA'" v-for="item in serverList"
          class="item-list">
          <div class="first-info">
            <div class="first-wrap">
              <span class="host-name margin-bottom-20">主机名：</span>
              <span class="host-info">{{item.serverHostname}}</span>
            </div>
            <div class="first-wrap margin-left-40">
              <span class="host-name margin-bottom-20">备注：</span>
              <span class="host-info">{{item.serverNote}}</span>
            </div>
          </div>
          <div class="second-info">
            <div>拨号账号总数：</span> {{item.all_count}}</div>
            <div>拨号正常数量：<span class="right-circle"></span>{{item.normal_count}}</div>
            <div>拨号异常数量：<span class="error-circle"></span>{{item.abnormal_count}}
              <span v-if="item.abnormal_count" class="bonus-cursor margin-left-20 bonus-color"
                @click="showAccounts(item)">
                查看详情
              </span>
            </div>
            <div>未拨号
              <el-tooltip class="item" effect="dark" content="当提交更改成功但未进行过拨号操作时，点击查看详情可直接进行拨号" placement="top">
                <i class="el-icon-question"></i>
              </el-tooltip>：
              <span v-if="item.unDialList">
                <span class="error-circle"></span>
                <span class="bonus-cursor bonus-color" @click="showUndials(item)">
                  查看详情
                </span>
              </span>
              <span v-else>
                <span class="right-circle"></span>
                <span class="bonus-cursor bonus-color disabledTxt">
                  查看详情
                </span>
              </span>
            </div>
          </div>
        </div>
        <div v-if="serverList === 'NODATA'" class="no-data margin-20 text-align-center">
          当前拨号均正常
        </div>
      </BasiceLayout>
    </Layout>
    <!-- 账号详情 -->
    <el-dialog title="异常拨号信息" :visible.sync="showDialog" width="950px">
      <div>
        <div class="displax-flex">
          <div class="dial-left-wrap">
            账号
          </div>
          <div class="dial-right-wrap">
            密码
          </div>
          <div class="dial-right-wrap">
            ip
          </div>
          <div class="dial-right-wrap">
            vlan
          </div>
          <div class="dial-right-wrap dial-errormsg">
            错误信息
          </div>
          <div class="dial-right-wrap">
            时间
          </div>
        </div>
        <div v-for="item in accountList" class="displax-flex">
          <div class="dial-left-wrap">
            {{item.account}}
          </div>
          <div class="dial-right-wrap">
            {{item.password}}
          </div>
          <div class="dial-right-wrap">
            {{item.ip}}
          </div>
          <div class="dial-right-wrap">
            {{item.vlan}}
          </div>
          <div class="dial-right-wrap dial-errormsg">
            {{item.errMsg}}
          </div>
          <div class="dial-right-wrap">
            {{item.time}}
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="sure-unbind button" type="primary" @click="editDial"
          v-if="allDialList.dialConfigType == 0">{{ $t('edit') }}</div>
        <div v-else></div>
      </span>
      <!-- 内层编辑对话框 -->
      <el-dialog width="60%" title="编辑拨号信息" :visible.sync="showEditDialog" append-to-body :before-close="handleClose">
        <!-- 动态 可编辑表格(能正常匹配到cmdb的)-->
        <div class="title-undial title-unnormal">异常拨号信息</div>
        <el-table :data="oldErrorList" align="center" v-if="allDialList.dialConfigType == 0">
          <el-table-column label="线路带宽" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.mbps" placeholder="单位：Mbps" type='number'></el-input>
            </template>
          </el-table-column>
          <el-table-column label="拨号账号" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.account"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="拨号密码" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.password"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="VLAN端口" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.vlan1"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="多拨次数" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.count" placeholder="单位：次" type='number' min="1"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="绑定网卡Mac" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.mac" placeholder="选填"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="网卡名" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.nic" placeholder="选填"></el-input>
            </template>
          </el-table-column>
        </el-table>
        <!-- 动态 可编辑表格(编辑保存但未拨号的) -->
        <div class="title-undial">未拨号的信息
          <el-tooltip class="item" effect="dark" content="未拨号的信息为提交更改成功但未进行过拨号操作的拨号配置信息" placement="top">
            <i class="el-icon-question"></i>
          </el-tooltip>
        </div>
        <el-table :data="unDialList" align="center" v-if="allDialList.dialConfigType == 0">
          <el-table-column label="线路带宽" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.mbps" placeholder="单位：Mbps" type='number'></el-input>
            </template>
          </el-table-column>
          <el-table-column label="拨号账号" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.account"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="拨号密码" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.password"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="VLAN端口" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.vlan1"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="多拨次数" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.count" placeholder="单位：次" type='number' min="1"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="绑定网卡Mac" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.mac" placeholder="选填"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="网卡名" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.nic" placeholder="选填"></el-input>
            </template>
          </el-table-column>
        </el-table>
        <!-- 动态 展示表格(无法匹配到cmdb的异常账号) -->
        <div class="title-undial">未找到的拨号信息
          <el-tooltip class="item" effect="dark" content="未找到的拨号信息为后台操作提交的与机器上不匹配的拨号配置信息(不可编辑)" placement="top">
            <i class="el-icon-question"></i>
          </el-tooltip>
        </div>
        <el-table :data="unMatchList" align="center">
          </el-table-column>
          <el-table-column prop="mbps" label="线路带宽" align="center"></el-table-column>
          <el-table-column prop="account" label="拨号账号" align="center"></el-table-column>
          <el-table-column prop="password" label="拨号密码" align="center"></el-table-column>
          <el-table-column prop="vlan" label="VLAN端口" align="center"></el-table-column>
          <el-table-column prop="count" label="多拨次数" align="center"></el-table-column>
          <el-table-column prop="mac" label="绑定网卡Mac" align="center"></el-table-column>
          <el-table-column prop="nic" label="网卡名" align="center"></el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer text-align-center">
          <div class="sure-unbind button" type="primary" @click="handleSubmit">提交更改</div>
          <div class="sure-unbind button" type="primary" @click="handleDial('EDIT')" v-if="showDialBtn">拨号</div>
          <el-button v-else type="info" plain disabled class="disabledBtn">拨号</el-button>
          <div class="sure-unbind button" type="primary" @click="handleClose">取消</div>
        </div>
      </el-dialog>
    </el-dialog>
    <!-- 保存后未拨号 再次重拨的对话框 -->
    <!-- 封装table组件(后期待优化) -->
    <el-dialog width="60%" title="未拨号信息" :visible.sync="showUndialDialog">
      <el-table :data="unDialList" align="center">
        </el-table-column>
        <el-table-column prop="mbps" label="线路带宽" align="center"></el-table-column>
        <el-table-column prop="account" label="拨号账号" align="center"></el-table-column>
        <el-table-column prop="password" label="拨号密码" align="center"></el-table-column>
        <el-table-column prop="vlan1" label="VLAN端口" align="center"></el-table-column>
        <el-table-column prop="count" label="多拨次数" align="center"></el-table-column>
        <el-table-column prop="mac" label="绑定网卡Mac" align="center"></el-table-column>
        <el-table-column prop="nic" label="网卡名" align="center"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer text-align-center">
        <div class="sure-unbind button" type="primary" @click="handleDial('NOEDIT')">拨号</div>
        <div class="sure-unbind button" type="primary" @click="showUndialDialog = false">取消</div>
      </div>
    </el-dialog>
    <!-- 下载异常拨号信息表格 -->
    <el-table id="out-table" :data="exportErrDialList" align="center" style="display: none;">
        <el-table-column prop="account" label="账号" align="center"></el-table-column>
        <el-table-column prop="bandwidth" label="带宽" align="center"></el-table-column>
        <el-table-column prop="err_msg" label="错误信息" align="center"></el-table-column>
        <el-table-column prop="intf" label="拨号网卡名" align="center"></el-table-column>
        <el-table-column prop="ip" label="IP" align="center"></el-table-column>
        <el-table-column prop="ipv4_stat" label="ipv4状态" align="center"></el-table-column>
        <el-table-column prop="ipv6" label="ipv6地址" align="center"></el-table-column>
        <el-table-column prop="ipv6_stat" label="ipv6状态" align="center"></el-table-column>
        <el-table-column prop="jitter" label="抖动" align="center"></el-table-column>
        <el-table-column prop="nat_type" label="nat类型" align="center"></el-table-column>
        <el-table-column prop="ping" label="ping值" align="center"></el-table-column>
        <el-table-column prop="pl_avg" label="丢包率平均值" align="center"></el-table-column>
        <el-table-column prop="pl_max" label="最大丢包率" align="center"></el-table-column>
        <el-table-column prop="rtt_avg" label="rtt平均值" align="center"></el-table-column>
        <el-table-column prop="rtt_max" label="rtt最大值" align="center"></el-table-column>
        <el-table-column prop="server_name" label="主机名" align="center"></el-table-column>
        <el-table-column prop="upload" label="测速上行带宽" align="center"></el-table-column>
        <el-table-column prop="vlan_id" label="vlanID" align="center"></el-table-column>
  </el-table>
  </div>
</template>

<script>
  import moment from "moment";
  import XLSX from 'xlsx'
  import FileSaver from 'file-saver';
  import { Message } from "element-ui";
  import { mapState, mapActions, mapMutations } from "vuex";
  import Header from "@/components/Header.vue";
  import Layout from "@/components/DatePanel/Layout.vue";
  import BasiceLayout from "@/components/Common/BasicLayout.vue";

  export default {
    name: "home",
    components: {
      Header,
      Layout,
      BasiceLayout
    },
    data() {
      return {
        accountList: [], // 异常账号列表（后端返回的,不完整）
        allDialList: [], //所有的拨号配置信息（最原始的）
        oldErrorList: [], //完整的异常账号信息
        newErrorList: [], //异常账号信息（编辑更改过的）
        unDialList: [], //未拨号账号列表
        unDialInfo: [], //未拨号账号的拨号配置信息
        unMatchList: [], //cmdb里无法匹配到的异常账号信息
        allNormalList: [], //所有拨号配置中正常的信息
        allEditedList: [],//编辑后的所有异常账号信息
        afterEidtAllList: [], //所有拨号配置信息（正常的+替换已经编辑过的异常的）
        exportErrDialList: [], //导出异常拨号信息数据
        showEditDialog: false,
        showDialog: false,
        showUndialDialog: false,
        showDialBtn: false,
        isSaved: false,
        hostName: "",
      };
    }, 
    computed: mapState({
      total: state => state.dialStatus.total,
      normal: state => state.dialStatus.normal,
      error: state => state.dialStatus.error,
      serverList: state => state.dialStatus.serverList
    }),
    created() {
      let date_at = moment()
        .utc()
        .startOf("minute")
        .subtract(5, "minute")
        .valueOf();
      this.getDialStatus({ date_at, type: "error" });
      this.queryErrExportInfo();
    },
    methods: {
      ...mapActions([
        "getDialStatus",
        "getDialByHostname",
        "commitDialConfig",
        "setDial",
        "savedStatus",
        "exportDialErrInfo",
      ]),
      async exportInfo() {
        let tables = document.getElementById("out-table");
        let table_book = XLSX.utils.table_to_book(tables, { raw: true, cellDates: true });
        var table_write = XLSX.write(table_book, {
            bookType: "xlsx",
            bookSST: true,
            type: "array",
        });
        try {
          FileSaver.saveAs(
              new Blob([table_write], { type: "application/octet-stream" }),
              '异常拨号信息.xlsx'
          );
          Message.success('已下载');
        } catch (e) {
          Message.error('下载异常拨号信息失败');
        }
        return table_write;
      },
      async queryErrExportInfo() {
        this.exportErrDialList = [];
        try {
          const res = await this.exportDialErrInfo();
          this.exportErrDialList = res.data;
        } catch(error) {}
      },
      editDial() {
        const nowTime = new Date();
        const nowHour = nowTime.getHours();
        const nowMin = nowTime.getMinutes();
        var startHigh = nowHour >= 11 && nowHour < 14;
        var endHigh = nowHour >= 18 && nowHour < 24;
        startHigh = nowHour == 11 && nowMin < 30 ? false : startHigh;
        if( startHigh || endHigh ) {
          return Message.warning('高峰期11:30-14:00、18:00-24:00期间内禁止修改、重拨账号');
        } else {
          this.showEditDialog = true;
        }
      },
      // 记录编辑、拨号状态
      recordStatus(type, msg, isEdit) {
        let params;
        if (isEdit) {
          params = {
            bcode: this.allDialList.serverBcode,
            hostName: this.hostName,
            type,
            dialList: this.allEditedList,
          }
        } else {
          params = {
            bcode: this.unDialInfo.serverBcode,
            hostName: this.unDialInfo.serverHostname,
            type,
            dialList: this.unDialList
          }
        }
        this.savedStatus(params).then(res => {
          if (res && res.code == 200) {
            Message({
              type: "success",
              message: msg.success
            });
          } else {
            Message({
              type: "success",
              message: msg.error
            })
          }
        })
      },
      // 查看异常详情
      async showAccounts(item) {
        this.showDialog = true;
        this.showDialBtn = false;
        this.oldErrorList = [];
        this.unDialInfo = item;
        this.accountList = item.abnormal_list;
        this.hostName = item.serverHostname;
        this.unDialList = eval('(' + item.unDialList + ')');

        //根据主机名获取拨号配置信息
        const res = await this.getDialByHostname({ hostName: item.serverHostname });
        if (res.code !== 200) {
          return Message({
            type: 'error',
            message: res.message
          })
        }
        this.allDialList = res.result[0];
        const { dialAccounts } = this.allDialList;
        const diaAccountsList = eval('(' + dialAccounts + ')');

        // 处理从cmdb里查出来的数据格式(待优化？)
        diaAccountsList.forEach(item => {
          if (typeof (item.account) == "number") {
            item.account = item.account.toString();
          } else {
            item.account = item.account.replace(/(^\s*)|(\s*$)/g, "");
          }
        });

        // 获取异常账号完整信息
        for (var i = 0; i < this.accountList.length; i++) {
          diaAccountsList.filter((item) => {
            if (item.account == this.accountList[i].account) {
              this.oldErrorList.push(item);
            }
          })
        }

        //异常账号重复的话需要去重，只在总拨号数组里查询一次
        for (var i = 0; i < this.oldErrorList.length; i++) {
          for (var j = i + 1; j < this.oldErrorList.length; j++) {
            if (this.oldErrorList[i].account == this.oldErrorList[j].account) {
              this.oldErrorList.splice(j, 1);
              j--;
            }
          }
        }

        //获取cmdb里无法匹配到的异常账号信息
        this.unMatchList = this.accountList.filter(item1 => {
          const isTrue = diaAccountsList.filter(item2 => {
            return item2.account == item1.account
          })[0];
          return !isTrue
        })

        //编辑未拨号信息和异常拨号信息如果存在重复，默认删除编辑未拨号里的，只保留展示在异常账号里
        if (this.unDialList) {
          for (var i = 0; i < this.oldErrorList.length; i++) {
            for (var j = 0; j < this.unDialList.length; j++) {
              if (this.oldErrorList[i].account == this.unDialList[j].account) {
                this.unDialList.splice(j, 1);
              }
            }
          }
        }

        //获取所有正常的拨号配置信息 在所有拨号配置信息中去除原始的异常账号信息（为了拼接编辑后的新的信息）
        var allEditList = [];
        if (this.unDialList) {
          allEditList = [...this.oldErrorList, ...this.unDialList];
        } else {
          allEditList = [...this.oldErrorList];
        }

        this.allNormalList = diaAccountsList.filter(item1 => {
          const isUnnormal = allEditList.filter(item2 => {
            return item2.account === item1.account
          })[0]
          return !isUnnormal
        })
      },
      async handleSubmit() {
        this.newErrorList = this.oldErrorList;
        if (this.unDialList) {
          this.allEditedList = [...this.newErrorList, ...this.unDialList];
        } else {
          this.allEditedList = this.newErrorList;
        }

        // 提交参数非空验证
        var flag = true;
        if (this.allEditedList.length == 0) {
          return Message({
            type: 'error',
            message: '提交信息为空'
          })
        };
        this.allEditedList.map((item, index) => {
          if (this.allDialList.dialConfigType == 0) {
            if (!item.account || !item.mbps || !item.password) {
              flag = false;
              return Message({
                type: "error",
                message: `第${index + 1}行未填写`
              });
            }
          } else {
            if (!item.ip || !item.gateway || !item.segment) {
              flag = false;
              return Message({
                type: "error",
                message: `第${index + 1}行未填写`
              });
            }
          }
        })

        // 禁止修改成重复的拨号账号(后期待优化循环)
        if (flag) {
          for (var i = 0; i < this.allEditedList.length; i++) {
            for (var j = i + 1; j < this.allEditedList.length; j++) {
              if (this.allEditedList[i].account == this.allEditedList[j].account) {
                return Message({
                  type: 'error',
                  message: '拨号账号不能重复！'
                })
              }
            }
          }
          this.afterEidtAllList = [...this.allNormalList, ...this.allEditedList];
          const { dialConfigName, dialConfigType, dialConfigID } = this.allDialList;
          const res = await this.commitDialConfig({
            dialConfigs: this.afterEidtAllList,
            dialConfigName,
            commitType: 'EDIT',
            dealDialId: dialConfigID,
            dialConfigType,
          });
          if (res.status == 200) {
            this.isSaved = true;
            this.showDialBtn = true;
            const msg = { success: '编辑成功，请拨号', error: '编辑成功，记录失败' };
            this.recordStatus(0, msg, true);
          } else {
            Message({
              type: "error",
              message: "编辑失败，请重试"
            });
          }
        }
      },
      // 拨号
      async handleDial(dialType) {
        const nowTime = new Date();
        const nowHour = nowTime.getHours();
        const nowMin = nowTime.getMinutes();
        var startHigh = nowHour >= 11 && nowHour < 14;
        var endHigh = nowHour >= 18 && nowHour < 24;
        startHigh = nowHour == 11 && nowMin < 30 ? false : startHigh;
        if( startHigh || endHigh ) {
          return Message.warning('高峰期11:30-14:00、18:00-24:00期间内禁止修改、重拨账号');
        }
        let params;
        if (dialType == 'EDIT') {
          params = {
            "serverId": this.allDialList.serverID,
            "serverBcode": this.allDialList.serverBcode,
            "data": this.allEditedList
          }
        } else {
          params = {
            "serverId": this.unDialInfo.serverId,
            "serverBcode": this.unDialInfo.serverBcode,
            "data": this.unDialList
          }
        }
        const dialRes = await this.setDial(params);
        this.showDialBtn = false;
        if (dialRes && dialRes.code == 200) {
          this.showEditDialog = false;
          this.showDialog = false;
          this.showUndialDialog = false;
          const msg = { success: '拨号指令已发出', error: '拨号指令已发出，记录失败' };
          let isEdit;
          dialType == 'EDIT' ? isEdit = true : isEdit = false;
          this.recordStatus(1, msg, isEdit);
        } else {
          return Message({
            type: 'error',
            message: dialRes.message || '拨号失败，请重试'
          })
        }
      },
      // 保存但未拨号 警告
      async handleClose(done) {
        if (this.isSaved) {
          this.$confirm('未拨号，确认关闭？')
            .then(_ => {
              this.showEditDialog = false;
            })
            .catch(_ => { });
        } else {
          this.showEditDialog = false;
          // done();
        }
        this.isSaved = false;
      },
      //查看保存未拨号的详情
      showUndials(item) {
        this.showUndialDialog = true;
        this.unDialInfo = item;
        this.unDialList = eval('(' + item.unDialList + ')');
      }
    }
  }
</script>

<style scoped lang="stylus">
  .basic-layout-wrap {
    background: #fff;
    border: 1px solid #e3e3e7;
    position: relative;
  }

  .dial-status-home .item-list {
    border-bottom: 1px solid #ddd;
    margin: 20px;
  }

  .dial-status-home .second-info {
    display: flex;
    margin: 20px;

    // padding: 0 20px;
    div {
      width: 33.33%;
    }
  }

  .dial-status-home .first-info {
    display: flex;
    margin: 20px;

    .first-wrap {
      // margin: 20px;
      // padding: 0 20px;
    }
  }

  .dial-left-wrap,
  .dial-right-wrap {
    width: 50%;
    text-align: center;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .host-info {
    color: #65686a;
  }

  .right-circle {
    width: 10px;
    height: 10px;
    display: inline-block;
    border-radius: 5px;
    background-color: #1add75;
    margin-right: 10px;
  }

  .error-circle {
    width: 10px;
    height: 10px;
    display: inline-block;
    border-radius: 5px;
    background-color: red;
    margin-right: 10px;
  }

  .disabledBtn {
    width: 90px;
    height: 35px;
    text-align: center;
    border-radius: 0;
    font-weight: 400;
    font-style: PingFangSC-Regular;
    padding: 0;
  }

  .disabledTxt {
    color: #c3c3c3;
    cursor: not-allowed;
  }

  .dial-errormsg {
    width: 70%;
    padding: 0 30px;
  }

  .title-undial {
    text-align: center;
    margin: 70px 0 10px 0;
    font-size: 16px;
    font-weight: bold;
  }

  .title-unnormal {
    margin: 10px 0 10px 0;
  }
</style>